<template>
  <el-button type="primary" @click="handleExport" plain>
    <i class="iconfont">&#xe6ad;</i>{{ btnName }}
  </el-button>
</template>

<script>
import {
  exportPost,
  exportDownloadFile,
} from 'api';
import {
  downloadExcelFileAsyn,
} from '@qx/utils';
const md5 = require('md5');
export default {
  props: {
    btnName: {
      type: String,
      default: '导出',
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    queryUrl: {
      type: String,
      default: '',
    },
    bizName: {
      type: String,
      default: '',
    },
    bizCode: {
      type: String,
      default: '',
    },
    excelKeys: {
      type: String,
      default: '',
    },
    excelLables: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    len: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    async handleExport () {
      if (this.len === 0) {
        this.$message.info('没有数据');
        return;
      }
      let result = '';
      const ignoreParams = ['page', 'rows', 'tableName'];
      const resultParams = {
        ...this.params,
        currentTime: new Date().getTime(),
        queryUrl: this.queryUrl.replace('?', '|').replace('.ajax', '').replace('cmd=', ''),
        excelLables: this.excelLables,
        excelKeys: this.excelKeys,
        fileName: this.fileName,
        _ALLEXPORT: 1,
        isAsyn: this.type === 'sync' ? '' : 1,
      };
      Object.keys(resultParams).sort().forEach((key) => {
        if ((resultParams[key] || resultParams[key] === 0) && ignoreParams.indexOf(key) === -1) {
          result += `${key}=${resultParams[key]}&`;
        }
      });
      if (result.length === 0) {
        result = '&';
      }
      result = md5(result.substr(0, result.length - 1));
      if (this.type === 'sync') {
        this.applyRenderFile(result, 'sync');
      } else {
        const res = await exportPost({
          queryUrl: this.queryUrl,
          bizName: this.bizName,
          bizCode: this.bizCode,
          result: result + '#' + this.bizName,
        });
        if (!res.failed) {
          this.applyRenderFile(result);
          this.$confirm('任务提交成功，请前往‘导入导出结果查询’查看', '提示', {
            confirmButtonText: '查看导出结果',
            cancelButtonText: '取消',
          }).then(() => {
            this.jump({
              label: '导出结果查询',
              url: '/manage/system/importExport/export',
            });
          }).catch(() => {
            console.log('cancel');
          });
        }
      }
    },
    async applyRenderFile (result, type) {
      const queryBo = this.queryUrl.substr(0, this.queryUrl.indexOf('.ajax'));
      const sRes = await exportDownloadFile({
        urlPrefix: queryBo,
        ...this.params,
        queryUrl: this.queryUrl.replace('?', '|').replace('.ajax', '').replace('cmd=', ''),
        excelKeys: this.excelKeys,
        excelLables: this.excelLables,
        currentTime: this.formatDate(new Date(), 1).replace(/[\s+\:\-\:]/g, ''),
        _ALLEXPORT: 1,
        fileName: this.bizName,
        isAsyn: type === 'sync' ? null : 1,
        tableName: result,
      });
      if (!sRes.failed && type) { // 同步
        downloadExcelFileAsyn({
          urlType: '',
          queryUrl: this.queryUrl,
          tableName: result,
        });
      }
    },
  },
};
</script>

<style>

</style>
